var update = require("!../../../node_modules/style-loader/lib/addStyleUrl.js")(
  require("!!../../../node_modules/file-loader/dist/cjs.js!./fonts.css")
, {"hmr":true});
if(module.hot) {
  module.hot.accept("!!../../../node_modules/file-loader/dist/cjs.js!./fonts.css", function() {
    update(require("!!../../../node_modules/file-loader/dist/cjs.js!./fonts.css"));
  });

  module.hot.dispose(function() { update(); });
}